import React from 'react';
import { MonitoringLiveDemo } from './MonitoringLiveDemo';

const MonitoringSection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-background overflow-hidden">
      {/* Grade fina remetendo a gráfico/planilha, desvanecendo nas bordas — identidade própria da seção de progresso. */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.5] dark:opacity-[0.15]"
        style={{
          backgroundImage:
            'linear-gradient(rgb(var(--warm)) 1px, transparent 1px), linear-gradient(90deg, rgb(var(--warm)) 1px, transparent 1px)',
          backgroundSize: '42px 42px',
          maskImage: 'radial-gradient(ellipse 70% 60% at center, black 0%, transparent 75%)',
          WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at center, black 0%, transparent 75%)',
        }}
        aria-hidden="true"
      />

      <div className="relative container mx-auto px-6 lg:px-16 xl:px-24 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-foreground">
          Você <span className="text-warm-ink dark:text-warm">acompanha</span> cada progresso
        </h2>
        <p className="font-body text-lg text-muted-foreground mt-4 max-w-2xl mx-auto">
          Professores, terapeutas e famílias enxergam a evolução em tempo real, com registros
          organizados por atividade.
        </p>

        <div className="mt-12 text-left max-w-4xl mx-auto">
          <MonitoringLiveDemo />
        </div>
      </div>
    </section>
  );
};

export default MonitoringSection;
